import {Button} from "@luciad/ria-sample-common/components/button/Button";
import {ButtonGroup} from "@luciad/ria-sample-common/components/ButtonGroup";
import {Modal} from "@luciad/ria-sample-common/components/Modal";
import {useMapContext} from "@luciad/ria-sample-common/hooks/useMapContext";
import {useToastContext} from "@luciad/ria-sample-common/hooks/useToast";
import {Map} from "@luciad/ria/view/Map";
import React from "react";
import {addLayer} from "../DataFormatsUtil";
import {BingMapsDataLoader, BingMapsType} from "../loaders/BingMapsDataLoader";

interface BingMapsButton {
  text: string;
  bingType: BingMapsType;
}

const BING_MAPS_BUTTONS: BingMapsButton[] = [
  {
    text: "Bing Maps Aerial",
    bingType: "aerial"
  },
  {
    text: "Bing Maps Road",
    bingType: "road"
  },
  {
    text: "Bing Maps Aerial with labels",
    bingType: "AerialWithLabels"
  },
  {
    text: "Bing Maps Canvas Light",
    bingType: "CanvasLight"
  },
  {
    text: "Bing Maps Canvas Dark",
    bingType: "CanvasDark"
  },
  {
    text: "Bing Maps Canvas Gray",
    bingType: "CanvasGray"
  }
];

const addBingMapsLayer = async (map: Map, bingType: BingMapsType): Promise<void> => {
  const bingLayer = await BingMapsDataLoader.createLayer(bingType);
  const existingBingLayer = map.layerTree.findLayerById("Bing");
  if (existingBingLayer) {
    map.layerTree.removeChild(existingBingLayer);
  }
  await addLayer(map, bingLayer);

  // make sure text is legible by enabling scale snapping
  const oldSnapValue = map.mapNavigator.defaults.snapToScaleLevels;
  map.mapNavigator.defaults.snapToScaleLevels = true;
  map.layerTree.on("NodeRemoved", function(event) {
    if (event.node === bingLayer) {
      map.mapNavigator.defaults.snapToScaleLevels = oldSnapValue;
    }
  });
}

interface Props {
  show: boolean;
  onHide: () => void;
}

export const AddBingMapsModal = ({show, onHide}: Props) => {
  const {map} = useMapContext();
  const {showErrorToast} = useToastContext();

  const handleButtonClick = (button: BingMapsButton) => {
    addBingMapsLayer(map, button.bingType).catch((error) => {
      showErrorToast(error.message, error);
    });
    onHide();
  };

  return (
      <Modal show={show} title="Add Bing Maps" onHide={onHide}>
        <ButtonGroup vertical={true}>
          {BING_MAPS_BUTTONS.map((button) => {
            return (
                <Button key={button.text} onClick={() => handleButtonClick(button)}>{button.text}</Button>
            )
          })}
        </ButtonGroup>
      </Modal>
  )
}